import FormLesson from "@/views/lesson/FormLesson.vue";
import LessonDetail from "@/views/lesson/LessonDetail.vue";
import Lesson from "@/views/lesson/Lesson.vue";

export default [
    {
        path: "/lessons",
        name: "Lesson",
        component: Lesson,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/lessons/lesson/:id",
        name: "LessonDetail",
        component: LessonDetail,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/lessons/lesson/new-lesson",
        name: "NewLesson",
        component: FormLesson,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/lessons/update-lesson/:id",
        name: "UpdateLesson",
        component: FormLesson,
        meta: {
            requiresAuth: true
        }
    }
];
